import { Datagrid, SimpleList, TextField } from 'react-admin';
import { InfiniteList } from '@components/InfiniteList';
import { useMediaQuery, Theme } from '@mui/material';

export const SettingList = () => {
    const isSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('sm')
    );
    return (
        <InfiniteList>
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.name}
                    secondaryText={record => record.val}
                />
            ) : (
                <Datagrid>
                    <TextField source="name" />
                    <TextField source="val" />
                </Datagrid>
            )}
        </InfiniteList>
    );
};
